import { createAction, props } from '@ngrx/store';

import { DynamicFilter } from '../../../../api/models/dynamic-filter';
import { SupplierRequestListV1 } from '../../../../api/models';

/** 'all' = generic requests list; 'myRequests' = homepage Action Required list
 *  (persona OR-filter applied server-side by the my-requests endpoint). */
export type RequestListSource = 'all' | 'myRequests';

export const loadFirstPageRequests = createAction(
  '[Requests] Load First Page',
  props<{
    filters: DynamicFilter[];
    sortBy: string | undefined;
    sortDirection: 'ASC' | 'DESC' | undefined;
    source?: RequestListSource;
  }>()
);

export const loadNextPageRequests = createAction('[Requests] Load Next Page');

export const loadPageRequestsSuccess = createAction(
  '[Requests] Load Page Success',
  props<{
    content: SupplierRequestListV1[];
    continuationToken: string | null;
    hasMore: boolean;
  }>()
);

export const loadPageRequestsFailure = createAction('[Requests] Load Page Failure', props<{ error: unknown }>());

export const resetRequestsList = createAction('[Requests] Reset List');
